import { mbSize, Media } from '@foxrenderfarm/common'
import { Link } from 'gatsby'
import styled from 'styled-components'

export const Wrapper = styled.div<{ $showTopBanner: boolean }>`
  display: flex;
  width: 1200px;
  height: 50px;
  border-bottom: 1px solid #f3f3f3;
  position: sticky;
  top: ${({ $showTopBanner }) => ($showTopBanner ? '108px' : '60px')};
  background: #ffffff;
  z-index: 50;
  ${Media.lessThan(Media.small)} {
    width: 100vw;
    height: fit-content;
    top: ${mbSize(120)};
  }
`

export const TabWrapper = styled.div`
  display: flex;
  width: 100%;
  ${Media.lessThan(Media.small)} {
    position: relative;
    width: unset;
    overflow-x: auto;
    flex: 1;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const TabItem = styled(Link)<{ $isActive: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 50px;
  font-size: 16px;
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
  border-bottom: ${({ $isActive }) => ($isActive ? '1px solid #F3512B' : 'unset')};
  color: #333333;
  &:not(:last-child) {
    margin-right: 100px;
  }
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(90)};
    font-size: ${mbSize(28)};
    &:not(:last-child) {
      margin-right: ${mbSize(40)};
    }
  }
`

export const TabMaskWrapper = styled.div<{ $width: number }>`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: block;
    position: absolute;
    right: 0;
    width: ${({ $width }) => `${$width}px`};
    height: 100%;
    pointer-events: none;
  }
`

export const TabMask = styled.div<{ $type: 'left' | 'right' }>`
  position: absolute;
  left: ${({ $type }) => ($type === 'left' ? 0 : 'unset')};
  right: ${({ $type }) => ($type === 'left' ? 'unset' : 0)};
  height: 100%;
  width: ${mbSize(150)};
  background: ${({ $type }) =>
    $type === 'left'
      ? 'linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%)'
      : 'linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%)'};
`

export const MenuIcon = styled.div`
  display: none;
  ${Media.lessThan(Media.small)} {
    display: flex;
    align-items: center;
    height: ${mbSize(90)};
    padding: 0 ${mbSize(40)};
  }
`

export const CloseWrapper = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding: ${mbSize(40)} ${mbSize(60)};
`

export const CloseIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${mbSize(60)};
  height: ${mbSize(60)};
  border-radius: ${mbSize(4)};
  background: #fff4f1;
`
